"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _state = require("printableWorksheets/state");
var _react = _interopRequireDefault(require("react"));
require("./styles.scss");
var _state2 = require("../../state");
var _events = _interopRequireDefault(require("printableWorksheets/events"));
var _printableWorksheets = require("printableWorksheets");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var GradeSelector = function GradeSelector() {
  var _usePrintableWorkshee = (0, _state.usePrintableWorksheetsState)(),
    activeGrade = _usePrintableWorkshee.activeGrade,
    onboardingGrade = _usePrintableWorkshee.onboardingGrade,
    setActiveGrade = _usePrintableWorkshee.setActiveGrade,
    worksheetsEnvironment = _usePrintableWorkshee.worksheetsEnvironment;
  var gradesToTitleMapper = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _state2.Grades.ALL_GRADES, 'All Grades'), _state2.Grades.PRE_K, 'Pre-K'), _state2.Grades.K, 'K'), _state2.Grades.ONE, '1'), _state2.Grades.TWO, '2'), _state2.Grades.THREE, '3'), _state2.Grades.FOUR, '4'), _state2.Grades.FIVE, '5');
  var setGradeAndFireEvent = function setGradeAndFireEvent(grade) {
    setActiveGrade(_state2.Grades[grade]);
    var props = {
      clickedOn: 'Grade Selector',
      grade: onboardingGrade,
      newTopicSelected: '',
      newGradeSelected: grade
    };
    _events["default"].interactedPrintablesFilters(props);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "grade-selector",
    "data-sentry-component": "GradeSelector",
    "data-sentry-source-file": "gradeSelector.tsx"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "heading"
  }, "Grade"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "grades-container"
  }, Object.keys(_state2.Grades).filter(function (grade) {
    if (worksheetsEnvironment === _printableWorksheets.WorksheetsEnvironment.TEACHER_DASHBOARD) {
      if (_state2.Grades[grade] == _state2.Grades.PRE_K) return false;else return true;
    } else {
      return true;
    }
  }).map(function (grade, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: grade + index,
      onClick: function onClick() {
        return setGradeAndFireEvent(grade);
      },
      className: "grade ".concat(_state2.Grades[grade] == activeGrade ? 'selected' : '')
    }, gradesToTitleMapper[_state2.Grades[grade]]);
  })));
};
var _default = exports["default"] = GradeSelector;